import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';

const forOneApp = (ComponentOneApp, ComponentNonOneApp) => {
  const ForOneApp = ({ isOneApp, ...props }) => {
    const Component = isOneApp ? ComponentOneApp : ComponentNonOneApp;
    return <Component {...props} />;
  };

  ForOneApp.propTypes = {
    isOneApp: PropTypes.bool.isRequired,
  };

  const mapStateToProps = state => ({
    isOneApp: isOneApp(state),
  });

  return connect(mapStateToProps)(ForOneApp);
};

export default forOneApp;
